// Enums che corrispondono a quelli del backend Java
export enum NoticeType {
  SINGLE = 'SINGLE',
  RECURRING = 'RECURRING'
}

export enum ScheduleType {
  THIRD_WEDNESDAY = 'THIRD_WEDNESDAY',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY'
}

export enum NoticeSeverity {
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

// DTO che corrisponde alla struttura del backend
export interface ScheduledNoticeDTO {
  id?: number;
  title: string;
  message: string;
  type: NoticeType;
  isActive: boolean;
  scheduleType?: ScheduleType;
  startDate?: string; // LocalDate serializzato come string (YYYY-MM-DD)
  endDate?: string;   // LocalDate serializzato come string (YYYY-MM-DD)
  startTime?: string; // LocalTime serializzato come string (HH:mm:ss)
  endTime?: string;   // LocalTime serializzato come string (HH:mm:ss)
  severity: NoticeSeverity;
  createdAt?: string; // LocalDateTime serializzato come string
  updatedAt?: string; // LocalDateTime serializzato come string
}

// Response wrapper che corrisponde al backend
export interface ScheduledNoticeResponse {
  success: boolean;
  message: string;
  data: ScheduledNoticeDTO[];
}

// Request per creare/aggiornare avvisi
export interface CreateScheduledNoticeRequest {
  title: string;
  message: string;
  type: NoticeType;
  isActive?: boolean;
  scheduleType?: ScheduleType;
  startDate?: string;
  endDate?: string;
  startTime?: string;
  endTime?: string;
  severity?: NoticeSeverity;
}

export interface UpdateScheduledNoticeRequest extends CreateScheduledNoticeRequest {
  id: number;
}

// Request per toggle status
export interface ToggleScheduledNoticeRequest {
  isActive: boolean;
}
